import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { StockInfoPageService } from './service/stock-info-page.service';
import { TreeNode } from 'primeng/api';
import { NotificationService } from 'src/app/services/notification/notification.service';
import {
	faArrowsToDot,
	faDownload,
	faInfoCircle,
	faMagnifyingGlassMinus,
	faMagnifyingGlassPlus,
	faPlus,
	faSortDown,
	faSortUp,
} from '@fortawesome/free-solid-svg-icons';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { ProfileService } from 'src/app/services/profile/profile.service';
import * as internal from 'node:stream';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { FilesService } from 'src/app/services/files/files.service';
import { forkJoin, switchMap } from 'rxjs';
import { GenericFormGenService } from 'src/app/page_component_item/generic-form-gen/service/generic-form-gen.service';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { ShkDate } from 'shk-date';
import { GlobalService } from 'src/app/services/global/global.service';
import { DateService } from 'src/app/services/date/date.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-stock-info-page',
	templateUrl: './stock-info-page.component.html',
	styleUrls: ['./stock-info-page.component.scss'],
})
export class StockInfoPageComponent implements OnInit {
	icons = {
		faSortDown: faSortDown,
		faSortUp: faSortUp,
		faDownload: faDownload,
		faPlus: faPlus,
		faInfoCircle: faInfoCircle,
		faMagnifyingGlassPlus: faMagnifyingGlassPlus,
		faMagnifyingGlassMinus: faMagnifyingGlassMinus,
		faArrowsToDot: faArrowsToDot,
	};
	todayDate = this.formatDateToService(new Date());

	labels: LabelsInterface = {
		lbl_geral_status: 'Status',
		lbl_edocs_carregando: 'Loading',
		lbl_geral_notas_adicionais: 'Additional notes',
		lbl_geral_tag_id: 'Tag Id',
		lbl_geral_modelo: 'Model',
		lbl_asset_fabricante: 'Manufacturer',
		lbl_geral_login: 'Login',
		lbl_geral_identificacao: 'Identification',
		lbl_geral_nome: 'Name',
		lbl_geral_tipo: 'Type',
		lbl_geral_nome_do_host: 'Host name',
		lbl_asset_inventario: 'CMDB',
		lbl_geral_informacoes_gerais: 'General information',
		lbl_geral_sim: 'Yes',
		lbl_geral_nao: 'No',
		lbl_certeza_deletar: 'Are you sure you want to delete',
		lbl_deletar_afeta_filhos: 'Deleting this CI may affect your children',
		lbl_geral_adicionar: 'Add',
		lbl_asset_tipo_ci: 'Ci type',
		lbl_adicionar_no_filho_a: 'Add child node to',
		lbl_geral_cancelar: 'Cancel',
		lbl_preencha_todos_campos: 'Fill in all fields',
		lbl_adicionado_com_sucesso: 'Successfully added',
		lbl_removido_com_sucesso: 'Successfully removed',
		lbl_an_errour_occour: 'An error occurred. Please try again',
		lbl_geral_voltar: 'Back',
		lbl_geral_mapa_impacto: 'Impact map',
		lbl_geral_editar: 'Edit',
		lbl_erro_0011: 'ERROR: Labels not found',
		lbl_cmdb_nenhum_log: 'This CI has not changed since its inception',
		lbl_cmdb_nenhum_baseline: 'This CI has no recordings in that period',
		lbl_cmdb_legado_tente_novamente: 'TOP legacy information may be being ported, try again',
		lbl_rep_custom_arquivo_nao_encontrado: 'Archive not found',
		lbl_cmdb_visualizar_ci_sem_permissao: 'You are not allowed to view this type of ci',
		lbl_asset_impressora: 'Printer',
		lbl_cmdb_scanner: 'Scanner',
		lbl_asset_micro: 'Workstation',
		lbl_asset_servidor: 'Server',
		lbl_asset_roteador: 'Router',
		lbl_asset_inidade_fita: 'Tape_drive',
		lbl_geral_alicacao: 'Application',
		lbl_geral_banco_dados: 'Data_base',
		lbl_asset_contrato_manutencao: 'Maintenance_contract',
		lbl_cmdb_rack: 'Rack',
		lbl_cmdb_storage: 'Storage',
		lbl_cmdb_hub: 'Hub',
		lbl_cmdb_colocation: 'Colocation',
		lbl_cmdb_licenca: 'License',
		lbl_asset_fita: 'Tape',
		lbl_asset_banda_internet: 'Internet',
		lbl_cmdb_switch_port: 'Switch_port',
		lbl_projetos_politica_backup: 'Backup',
		lbl_cmdb_access_point: 'Access_point',
		lbl_cmdb_firewall: 'Firewall',
		lbl_cmdb_itservices: 'Itservice',
		lbl_asset_peripheral: 'Peripheral',
		lbl_geral_anexo: '',
		lbl_geral_responsavel: '',
		lbl_geral_dependente: '',
		lbl_cmdb_relacionamento: '',
		lbl_security_nenhum_registro: '',
		lbl_edocs_atualizacao_status: 'Status Update',
		lbl_cmdb_telefonia: 'Telephony',
		lbl_cmdb_origem_ativo: '',
		lbl_geral_cadastrado_por: '',
		lbl_geral_cadastro_manual: '',
		lbl_geral_origem_nao_encontrada: '',
		lbl_geral_exist_in_ad: 'Exists in AD',
		lbl_geral_not_exist_in_ad: 'Does not exist in AD',
		lbl_status_estoque: 'Stock',
		lbl_usuario_responsavel: '',
		lbl_geral_data_retorno: '',
		lbl_data_prevista_devolucao: '',
		lbl_sem_responsavel: '',
		lbl_status_em_uso: '',
		lbl_geral_quan_est: '',
		lbl_selecione_ci_visualizar_informacoes: '',
	};

	constructor(
		private StockInfoPageService: StockInfoPageService,
		private ActivatedRoute: ActivatedRoute,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private Router: Router,
		private ProfileService: ProfileService,
		private route: ActivatedRoute,
		private FilesService: FilesService,
		private GenericFormGenService: GenericFormGenService,
		private PermissionService: PermissionService,
		public DateService: DateService
	) {
		this.route.params.subscribe((parameters) => (this.citype = parameters['typeCi']));
	}

	tabView = 'ciInfo';

	impactMapData: TreeNode[] = [];
	relationshipNode: TreeNode = null;
	selectedCi: TreeNode = undefined;
	selectedCiForm: genericFormInterface[] = [];
	fieldDictionary = {};
	ciLogs: logInterface[] = [];
	statusCiLogs: logInterface[] = [];
	ciAttachments: mspFileInterface[] = [];

	isLoadingLabels = true;
	isLoadingImpactMap = true;
	isLoadingLogs = true;
	isLoadingRelationship = true;
	isLoadingCmdbInfo = false;
	isLoadingCiChildrens = false;
	isLoadingCiParents = false;
	isLoadingDynamicSubSelect = []; //É adicionado valores dentro do array dinamicamente a cada requisição, o carregamento está finalizado quando não há itens.

	canEditCi = true;
	citype: string;

	existingInAd = false;
	existInAd = false;
	notExistInAd = false;

	mainCol = 'info';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.ActivatedRoute.params.subscribe((parameter) => {
			if (parameter.idUser) {
				this.StockInfoPageService.getAllCiRelatedToUser(parameter.idUser).subscribe((impactMapRes) => {
					this.impactMapData[0] = impactMapRes;
					this.isLoadingImpactMap = false;
				});
			}
		});
	}

	onNodeSelect(selectNodeEvent: any): void {
		const selectedNode = selectNodeEvent.node;
		this.impactMapPos.centerX = this.impactMapPos.x;
		this.impactMapPos.centerY = this.impactMapPos.y;
		this.mouseUpImpactMap();

		this.isLoadingCmdbInfo = true;
		this.StockInfoPageService.getCiEditPermission(selectedNode.data.type).subscribe((permissions) => {
			if (!this.PermissionService.hasPermission(permissions.view_permission)) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_visualizar_ci_sem_permissao);
				this.isLoadingCmdbInfo = false;
				return;
			}

			this.canEditCi = this.PermissionService.hasPermission(permissions.edit_permission);
			this.selectedCi = selectedNode;
			this.StockInfoPageService.getCiLogs(this.selectedCi.data.cmdbId).subscribe((ciLogs) => {
				this.ciLogs = ciLogs;
			});
			this.StockInfoPageService.getFileList(this.selectedCi.data.cmdbId).subscribe((fileList) => {
				this.ciAttachments = fileList;
			});
			this.StockInfoPageService.getCiRelationship(this.selectedCi.data.cmdbId).subscribe((relations) => {
				this.relationshipNode = relations;
			});
			this.StockInfoPageService.getCiStatus(this.selectedCi.data.cmdbId).subscribe((statusLog) => {
				this.statusCiLogs = statusLog;
			});

			this.generateCiForm();
		});
	}

	expandCiTreeDown(event: Event, selectedCi: TreeNode): void {
		this.mouseUpImpactMap();
		if (event) event.stopPropagation();
		if (this.isLoadingCiChildrens) return;
		this.isLoadingCiChildrens = true;
		this.StockInfoPageService.getCiChildren(selectedCi.data.ciArray[0].id).subscribe(
			(requesitionFork) => {
				requesitionFork.subscribe(
					(childrenArray) => {
						selectedCi.data.isLeaf = false;
						const existingChild = selectedCi.children;
						for (const childRes of childrenArray) {
							let childAlreadyExist = false;
							for (const temporaryChild of existingChild) {
								if (temporaryChild.data.ciArray[0].id.toString() == childRes.data.ciArray[0].id.toString())
									childAlreadyExist = true;
							}
							if (!childAlreadyExist) selectedCi.children.push(childRes);
						}
						for (const child of selectedCi.children) {
							child.data.isRoot = false;
						}
						const temporaryImpactMapData = [...this.impactMapData];
						this.impactMapData = [];
						setTimeout(() => {
							this.impactMapData = temporaryImpactMapData;
							this.isLoadingCiChildrens = false;
						}, 1);
					},
					(errorRes) => {
						this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_legado_tente_novamente);
					}
				);
			},
			(errorRes) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_legado_tente_novamente);
			}
		);
	}

	expandCiTreeUp(event: Event, selectedCi: TreeNode): void {
		this.mouseUpImpactMap();
		event.stopPropagation();
		if (this.isLoadingCiParents) return;
		this.isLoadingCiParents = true;
		this.StockInfoPageService.getCiParent(selectedCi.data.ciArray[0].id).subscribe(
			(requesitionFork) => {
				requesitionFork.subscribe(
					(parrentArray) => {
						selectedCi.data.isRoot = false;
						const newRoot: TreeNode<any>[] = parrentArray;
						selectedCi.parent = parrentArray[0];
						selectedCi.parent.data.isLeaf = false;
						const temporaryImpactMapData = [...this.impactMapData];
						newRoot[0].children = temporaryImpactMapData;
						this.impactMapData = [];
						setTimeout(() => {
							this.impactMapData = newRoot;
							//Ao subir o nó, verificar se o nó possui outros filhos além de onde veio a requisição
							this.expandCiTreeDown(null, this.impactMapData[0]);
							this.isLoadingCiParents = false;
						}, 1);
					},
					(errorRes) => {
						this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_legado_tente_novamente);
					}
				);
			},
			(errorRes) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_legado_tente_novamente);
			}
		);
	}

	generateCiForm(idCi?: string): void {
		this.isLoadingCmdbInfo = true;

		forkJoin([
			this.StockInfoPageService.getRegisterForm(this.selectedCi.data.type),
			this.StockInfoPageService.getCiBaselineData(this.selectedCi.data.cmdbId, new ShkDate().getDate()),
		]).subscribe((forkRes) => {
			const ciForm = forkRes[0];
			const ciData = forkRes[1];
			this.selectedCi.data.ciArray = ciData.ciArray;

			const newCiFormArray: genericFormInterface[] = [];
			for (const formItem of ciForm) {
				const newCiForm: genericFormInterface = {
					id: '',
					name: formItem.name,
					disabled: true,
					inputType: formItem.inputType === 'multi-input' ? formItem.inputType : 'text',
					label: formItem.label,
					values: [formItem.values],
					rawValues: [formItem.values],
					hidden: formItem.hidden,
					subSelect: formItem.subSelect,
				};

				for (const key of Object.keys(this.selectedCi.data.ciArray[0])) {
					if (key === formItem.name) {
						formItem.values[0] = this.selectedCi.data.ciArray[0][key];
						newCiForm.rawValues[0] = this.selectedCi.data.ciArray[0][key];
						if (formItem.items && formItem.items.length > 0) {
							for (const item of formItem.items) {
								if (item.values[0] === formItem.values[0]) {
									formItem.values[0] = item.label || item.value;
								}
							}
						}

						if (formItem.inputType === 'date') {
							formItem.values[0] = this.DateService.formatDate(formItem.values[0]);
						}
						if (formItem.inputType === 'boolean') {
							formItem.values[0] === true || formItem.values[0] === 'true' || formItem.values[0] === 1
								? (formItem.values[0] = this.labels.lbl_geral_sim)
								: (formItem.values[0] = this.labels.lbl_geral_nao);
						}
						if (formItem.name == 'type') {
							switch (formItem.values[0]) {
								case 1: {
									formItem.values[0] = this.labels.lbl_asset_impressora;
									break;
								}
								case 2: {
									formItem.values[0] = this.labels.lbl_cmdb_scanner;
									break;
								}
								case 3: {
									formItem.values[0] = this.labels.lbl_asset_micro;
									break;
								}
								case 4: {
									formItem.values[0] = this.labels.lbl_asset_servidor;
									break;
								}
								case 5: {
									formItem.values[0] = this.labels.lbl_asset_roteador;
									break;
								}
								case 8: {
									formItem.values[0] = this.labels.lbl_asset_inidade_fita;
									break;
								}
								case 9: {
									formItem.values[0] = this.labels.lbl_geral_alicacao;
									break;
								}
								case 10: {
									formItem.values[0] = this.labels.lbl_geral_banco_dados;
									break;
								}
								case 11: {
									formItem.values[0] = this.labels.lbl_asset_contrato_manutencao;
									break;
								}
								case 13: {
									formItem.values[0] = this.labels.lbl_cmdb_rack;
									break;
								}
								case 14: {
									formItem.values[0] = this.labels.lbl_cmdb_storage;
									break;
								}
								case 17: {
									formItem.values[0] = this.labels.lbl_cmdb_hub;
									break;
								}
								case 19: {
									formItem.values[0] = this.labels.lbl_cmdb_colocation;
									break;
								}
								case 20: {
									formItem.values[0] = this.labels.lbl_cmdb_licenca;
									break;
								}
								case 21: {
									formItem.values[0] = this.labels.lbl_asset_fita;
									break;
								}
								case 22: {
									formItem.values[0] = this.labels.lbl_asset_banda_internet;
									break;
								}
								case 27: {
									formItem.values[0] = this.labels.lbl_cmdb_switch_port;
									break;
								}
								case 28: {
									formItem.values[0] = this.labels.lbl_projetos_politica_backup;
									break;
								}
								case 29: {
									formItem.values[0] = this.labels.lbl_cmdb_access_point;
									break;
								}
								case 30: {
									formItem.values[0] = this.labels.lbl_cmdb_firewall;
									break;
								}
								case 37: {
									formItem.values[0] = this.labels.lbl_cmdb_telefonia;
									break;
								}
								case 38: {
									formItem.values[0] = this.labels.lbl_cmdb_itservices;
									break;
								}
								case 39: {
									formItem.values[0] = this.labels.lbl_asset_peripheral;
									break;
								}
								default: {
									break;
								}
							}
						}
					}
				}

				newCiFormArray.push(newCiForm);
			}

			this.selectedCiForm = newCiFormArray;

			for (const formItem of this.selectedCiForm) {
				this.fieldDictionary[formItem.name] = formItem;
			}

			this.handleSubSelectLoad();
			this.showConsumablesFields();
			this.isLoadingCmdbInfo = false;
		});
	}

	getclickAd(): void {
		if (this.existingInAd) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_exist_in_ad);
		}
		if (!this.existingInAd) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_not_exist_in_ad);
		}
	}

	getCiBaseline(date: Date): void {
		this.tabView = 'ciInfo';
		const holdDate = '' + date;
		date = new Date(date);

		if (holdDate.split(' ').length <= 1) {
			date.setDate(date.getDate() + 1);
		}

		this.StockInfoPageService.getCiBaselineData(this.selectedCi.data.ciArray[0].id, this.formatDateToBaseline(date)).subscribe(
			(ciRes) => {
				if (ciRes.ciArray[0].idCustomer.toString() != this.ProfileService.userData().idCustomer.toString()) {
					this.NotificationService.setNotificationMessage(this.labels.lbl_rep_custom_arquivo_nao_encontrado);
					this.Router.navigate(['/cmdb/list']);
					return;
				}
				this.selectedCi.data = $.extend(true, {}, ciRes);
				this.onNodeSelect(this.selectedCi);
				this.todayDate = this.formatDateToService(date);
			},
			(errorRes) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_cmdb_nenhum_baseline);
			}
		);
	}

	formatDateToBaseline(date: Date): string {
		//Retorna data no formato ano-mes-dia-hora-minuto
		date = new Date(date);
		return `${this.formatDateToService(date)} ${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}`;
	}

	formatDateToService(date: Date): string {
		//Retorna data no formato ano-mes-dia
		date = new Date(date);
		return `${date.getFullYear()}-${date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}`;
	}

	downloadFile(index: number): void {
		this.StockInfoPageService.getFile(this.selectedCi.data.ciArray[0].id, this.ciAttachments[index].id).subscribe((mspFile) => {
			this.FilesService.downloadFile(this.FilesService.fileFromBase(mspFile, 'Base64'));
		});
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}

	navigateTo(to: string): void {
		this.Router.navigateByUrl(to);
	}

	/*Impact map drag stuff*/
	impactMapPos = {
		sX: 0,
		sY: 0,
		x: 0,
		y: 0,
		centerX: 0,
		centerY: 0,
		zoomLevel: 1,
		mouseDown: false,
		mouseMove: false,
	};

	mouseDownImpactMap = (e: MouseEvent) => {
		if (e.buttons != 1) return;
		this.impactMapPos.sX = e.clientX;
		this.impactMapPos.sY = e.clientY;
		this.impactMapPos.mouseDown = true;
	};

	confirmMouseMoveImpactMap = () => {
		if (!this.impactMapPos.mouseDown) return;
		this.impactMapPos.mouseMove = true;
	};

	moveImpactMap = (e: MouseEvent) => {
		const dx = e.clientX - this.impactMapPos.sX;
		const dy = e.clientY - this.impactMapPos.sY;

		this.impactMapPos.x = this.impactMapPos.x + dx;
		this.impactMapPos.y = this.impactMapPos.y + dy;

		this.impactMapPos.sX = e.clientX;
		this.impactMapPos.sY = e.clientY;
	};

	mouseUpImpactMap = () => {
		this.impactMapPos.mouseDown = false;
		this.impactMapPos.mouseMove = false;
	};
	/*End of impact map drag stuff*/
	showConsumablesFields(): void {
		const typeFormField = this.selectedCiForm.find((field) => field.name === 'type');
		const isConsumableField = this.selectedCiForm.find((field) => field.name === 'isConsumable');

		if (typeFormField && isConsumableField && typeFormField.values && typeFormField.values[0][0] === 'Periférico') {
			isConsumableField.hidden = false;
		} else if (isConsumableField) {
			isConsumableField.hidden = true;
		}
	}

	handleSubSelectLoad(): void {
		this.isLoadingDynamicSubSelect.push('§');
		for (const formItem of this.selectedCiForm) {
			formItem.subSelect?.forEach((subSelectItem: genericFormInterface['subSelect'][number]) => {
				const subSelectChildName = subSelectItem.subSelectChildName;
				const subSelectQryName = subSelectItem.subSelectQryName;
				const parameters = [];
				const fieldDictionaryKeys = Object.keys(this.fieldDictionary);

				if (subSelectItem.parameters)
					for (const parameter of subSelectItem.parameters) {
						let keyName = '';
						const temporaryParameter = (<any>parameter).replaceAll('%', '.*');
						const regex = new RegExp(`^${temporaryParameter}$`);
						for (const key of fieldDictionaryKeys) {
							if (regex.test(key)) keyName = key;
						}

						if (keyName != '') {
							const keyValue = this.fieldDictionary[keyName].rawValues[0];
							const newParameter = { key: keyName, value: keyValue };
							parameters.push(newParameter);
						}
					}

				if (
					subSelectChildName &&
					subSelectChildName != '' &&
					formItem.rawValues[0] &&
					(formItem.rawValues[0] != '' || formItem.rawValues[0] != '-1')
				) {
					this.isLoadingDynamicSubSelect.push('§');
					this.GenericFormGenService.getSubSelect(subSelectQryName, formItem.rawValues[0], parameters).subscribe(
						(subSelectItems) => {
							for (let index = 0; index < this.selectedCiForm.length; index++) {
								const formItem2 = this.selectedCiForm[index];
								if (formItem2.name === subSelectChildName) {
									formItem2.items = subSelectItems;

									for (const item of formItem2.items) {
										if (item.values[0] === formItem2.rawValues[0]) {
											formItem2.values[0] = item.label || item.value;
										}
									}
									break;
								}
							}
							this.isLoadingDynamicSubSelect.pop();
						}
					);
				}
			});
			this.isLoadingDynamicSubSelect.pop();
		}
	}

	onScroll(event: WheelEvent): void {
		event.deltaY > 0 ? this.zoomOut() : this.zoomIn();
	}

	zoomIn(): void {
		if (this.impactMapPos.zoomLevel === 3) return;
		this.impactMapPos.zoomLevel += 0.25;
	}

	zoomOut(): void {
		if (this.impactMapPos.zoomLevel === 0.5) return;
		this.impactMapPos.zoomLevel -= 0.25;
	}
}
